import React from "react";

const Education = () => {
  return <div></div>;
};

export default Education;
